









































































































































































































































































































































































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import {
  SetCardCriteriaCustomizationRequest,
  CardIssueCustomizationOptionType,
  CardCustomizationModel,
  EmployeeDisposition,
  manageableCardCustomizationOptionTypes
} from "@/admin/types";
import {
  FeePackageModel,
  FetchState,
  CardProvider,
  EmployerFeeScheduleTableItem,
  InterestRateTableItem,
  UserInterestRate,
  EmployerFeeSchedule
} from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useEmployerFeeScheduleStore } from "@/admin/store/employerFeeSchedule";
import { useEmployerInterestRateStore } from "@/admin/store/employerInterestRate";
import { usePartnerCardIssueCriteriaStore } from "@/admin/store/partnerCardIssueCriteria";
import { useNotifierStore } from "@/shared/store/notifier";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import _ from "lodash";
import * as cardIssueCustomizationOptionHelper from "@/admin/utilities/cardIssueCustomizationOptionHelper";
import { useThemeStore } from "@/shared/store/theme";
import { useFeePackageStore } from "@/admin/store/feePackage";
import { useMultiPurseOverrideStore } from "@/admin/store/multiPurseOverride";
import ManageCardCustomizationOptions from "@/admin/components/shared/ManageCardCustomizationOptions.vue";
import { formatCurrency } from "@/shared/currency";

const emptyCardCustomizationModel: CardCustomizationModel = {
  cardPlasticType: null,
  primaryPersonalizedEmbossingText: null,
  phoneNumber: null,
  url: null,
  issuerDefinedCardLogoCode: null,
  cardCarrierFrontTemplate: null,
  cardActivationLabel: null,
  feeScheduleId: null,
  cardProvider: CardProvider.Fiserv,
  fundPurseId: null,
  plansThatReceiveCards: [],
  usersMovedToThisEmployerWillBeIssuedNewCards: false,
  employeeDisposition: EmployeeDisposition.Default,
  fiservMultiPurseOverrideValueId: null
};

@Component({
  components: {
    GenericLoadingSpinner,
    ManageCardCustomizationOptions
  }
})
export default class CardSettings extends Vue {
  $validator: Validator;
  employerFeeScheduleStore = useEmployerFeeScheduleStore();
  employerInterestRateStore = useEmployerInterestRateStore();
  partnerCardIssueCriteriaStore = usePartnerCardIssueCriteriaStore();
  notifierStore = useNotifierStore();
  feePackageStore = useFeePackageStore();
  themeStore = useThemeStore();
  featureFlagStore = useFeatureFlagStore();
  multiPurseOverrideStore = useMultiPurseOverrideStore();
  isSubmitting = false;
  cardIssueCustomizationModel = emptyCardCustomizationModel;
  feePackageQuery = "";
  selectedPlansThatReceiveCards = [];
  plansThatReceiveCardsOptions = [];
  CardIssueCustomizationOptionType = CardIssueCustomizationOptionType;
  feeSchedulesModalIsOpen = false;
  interestRatesModalIsOpen = false;
  optionManagementModalParameters = {
    show: { value: false },
    optionType: CardIssueCustomizationOptionType.Unknown
  };

  // BEND-22219 this is temporary till a TBD refactor card is played.
  termedEmployeeCardStatusOptions = [
    { text: "Keep same card", value: true }
  ];

  @Prop ({ required: true })
  cardIssueCriteriaId: number;

  @Prop({ default: false })
  isEmployer: boolean;

  @Prop({ default: false })
  isReadonly: boolean;

  @Watch("isLoaded")
  isLoadedChange () {
    if (this.isLoaded) {
      this.copyCardIssueCustomization();
    }
  }

  @Watch("feePackagesLoaded")
  onFeePackagesLoaded () {
    if (this.isLoaded) {
      this.copyFeePackage();
    }
  }

  mounted () {
    this.$validator.extend("noWhiteSpace", this.noWhiteSpace);
    this.partnerCardIssueCriteriaStore.loadCardIssueCustomization(this.cardIssueCriteriaId);
    this.feePackageStore.loadFeePackages();
    this.multiPurseOverrideStore.loadMultiPurseOverrides();

    if (this.isLoaded) {
      this.copyCardIssueCustomization();
    }
  }

  get isLoaded () {
    return this.partnerCardIssueCriteriaStore.isCardIssueCustomizationLoaded(this.cardIssueCriteriaId);
  }

  get submitDisabled () {
    return !this.isValid || this.isSubmitting;
  }

  get isValid () {
    return !this.$validator.errors.any();
  }

  get plasticTypeOptions () {
    const options = this.partnerCardIssueCriteriaStore.cardIssueCustomizationOptions;
    return cardIssueCustomizationOptionHelper.getSelectOptions(options, CardIssueCustomizationOptionType.PlasticType);
  }

  get issuerDefinedCardLogoCodeOptions () {
    const options = this.partnerCardIssueCriteriaStore.cardIssueCustomizationOptions;
    return cardIssueCustomizationOptionHelper.getSelectOptions(options, CardIssueCustomizationOptionType.Logo);
  }

  get cardCarrierFrontTemplateOptions () {
    const options = this.partnerCardIssueCriteriaStore.cardIssueCustomizationOptions;
    return cardIssueCustomizationOptionHelper.getSelectOptions(options, CardIssueCustomizationOptionType.CardCarrierFrontTemplate);
  }

  get cardCardActivationLabelOptions () {
    const options = this.partnerCardIssueCriteriaStore.cardIssueCustomizationOptions;
    return cardIssueCustomizationOptionHelper.getSelectOptions(options, CardIssueCustomizationOptionType.CardActivationLabel);
  }

  get cardCriteriaPlanOptions () {
    const options = this.partnerCardIssueCriteriaStore.cardIssueCustomizationOptions;
    return cardIssueCustomizationOptionHelper.getSelectOptions(options, CardIssueCustomizationOptionType.CardCriteriaPlan);
  }

  get multiPurseFundOptions () {
    const options = this.partnerCardIssueCriteriaStore.cardIssueCustomizationOptions;
    return cardIssueCustomizationOptionHelper.getSelectOptions(options, CardIssueCustomizationOptionType.FundPurseId);
  }

  get multiPurseOverrideOptions () {
    return (this.multiPurseOverrideStore.multiPurseOverrides || [])
        .slice()
        .sort((a, b) => a.displayOrder - b.displayOrder);
    }

  get feePackagesLoaded () {
    return this.feePackageStore.fetchState === FetchState.Loaded;
  }

  get feePackageOptions () {
    return this.feePackageStore.feePackages;
  }

  get prependUrlScheme () {
    if (this.cardIssueCustomizationModel.url) {
      const urlTrimmed = this.cardIssueCustomizationModel.url.trim();
      return `https://${urlTrimmed}`;
    }

    return "#";
  }

  get feeSchedulesLoading () {
    return this.employerFeeScheduleStore.fetchState === FetchState.Loading;
  }

  get feeSchedulesFailed () {
    return this.employerFeeScheduleStore.fetchState === FetchState.Failed;
  }

  get feeSchedules () {
    return this.employerFeeScheduleStore.feeSchedules.map(fee => this.mapFeeScheduleTableItem(fee));
  }

  get interestRatesLoading () {
    return this.employerInterestRateStore.fetchState === FetchState.Loading;
  }

  get interestRatesFailed () {
    return this.employerInterestRateStore.fetchState === FetchState.Failed;
  }

  get interestRates () {
    return this.employerInterestRateStore.interestRates.map(tier => this.mapInterestRateTableItem(tier));
  }

  get isDisplayedUsersMovedToThisEmployerWillBeIssuedNewCards () {
    return this.featureFlagStore.featureFlags.bend26150AdminCardErGetsNewCardsOption;
  }

  get isMultiPurseOverrideEnabled () {
    return this.featureFlagStore.featureFlags.bend26527MultiPurseFundOverride;
  }

  get hideAdminCardFeesSection () {
    return this.featureFlagStore.featureFlags.bend27832HideAdminCardFeesSection;
  }

  mapFeeScheduleTableItem (fee: EmployerFeeSchedule): EmployerFeeScheduleTableItem {
    return {
      key: `${fee.packageName}|${fee.feeName}|${fee.feeAmount}`,
      packageName: fee.packageName,
      feeType: fee.feeName,
      amount: formatCurrency(fee.feeAmount)
    };
  }

  mapInterestRateTableItem (tier: UserInterestRate): InterestRateTableItem {
    return {
      balance: this.getInterestRateBalanceDisplay(tier),
      interestRate: this.getInterestRateDisplay(tier)
    };
  }

  getInterestRateBalanceDisplay (tier: UserInterestRate) {
    const balanceMin = formatCurrency(tier.balanceMin);

    if (tier.balanceMax > 0) {
      const balanceMax = formatCurrency(tier.balanceMax);
      return `${balanceMin} - ${balanceMax}`;
    }

    return `${balanceMin} and up`;
  }

  getInterestRateDisplay (tier: UserInterestRate) {
    const percent = tier.interestRate * 100;
    return `${percent.toFixed(2)}%`;
  }

  onShowInterestRatesModal () {
    this.interestRatesModalIsOpen = true;
  }

  onCloseInterestRatesModal () {
    this.interestRatesModalIsOpen = false;
  }

  onShowFeeSchedulesModal () {
    this.feeSchedulesModalIsOpen = true;
  }

  onCloseFeeSchedulesModal () {
    this.feeSchedulesModalIsOpen = false;
  }

  save () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      this.isSubmitting = true;

      let primaryPersonalizedEmbossingTextTrimmed = this.cardIssueCustomizationModel.primaryPersonalizedEmbossingText;
      if (this.cardIssueCustomizationModel.primaryPersonalizedEmbossingText) {
        primaryPersonalizedEmbossingTextTrimmed = this.cardIssueCustomizationModel.primaryPersonalizedEmbossingText.trim();
      }
      else {
        primaryPersonalizedEmbossingTextTrimmed = null;
      }

      let phoneNumberTrimmed = this.cardIssueCustomizationModel.phoneNumber;
      if (this.cardIssueCustomizationModel.phoneNumber) {
        phoneNumberTrimmed = this.cardIssueCustomizationModel.phoneNumber.trim();
      }
      else {
        phoneNumberTrimmed = null;
      }

      let urlTrimmed = this.cardIssueCustomizationModel.url;
      if (this.cardIssueCustomizationModel.url) {
        urlTrimmed = this.cardIssueCustomizationModel.url.trim();
      }
      else {
        urlTrimmed = null;
      }

      const model: CardCustomizationModel = {
        cardPlasticType: this.cardIssueCustomizationModel.cardPlasticType,
        primaryPersonalizedEmbossingText: primaryPersonalizedEmbossingTextTrimmed,
        phoneNumber: phoneNumberTrimmed,
        url: urlTrimmed,
        issuerDefinedCardLogoCode: this.cardIssueCustomizationModel.issuerDefinedCardLogoCode,
        cardCarrierFrontTemplate: this.cardIssueCustomizationModel.cardCarrierFrontTemplate,
        cardActivationLabel: this.cardIssueCustomizationModel.cardActivationLabel,
        feeScheduleId: this.cardIssueCustomizationModel.feeScheduleId,
        cardProvider: CardProvider.Fiserv,  // TODO: this will eventually have to be dynamic.
        fundPurseId: this.cardIssueCustomizationModel.fundPurseId,
        plansThatReceiveCards: this.selectedPlansThatReceiveCards,
        usersMovedToThisEmployerWillBeIssuedNewCards:
          this.cardIssueCustomizationModel.usersMovedToThisEmployerWillBeIssuedNewCards,
        employeeDisposition: EmployeeDisposition.Default,
        fiservMultiPurseOverrideValueId: this.cardIssueCustomizationModel.fiservMultiPurseOverrideValueId
      };

      const request: SetCardCriteriaCustomizationRequest = {
        default: model
      };

      return this.partnerCardIssueCriteriaStore.setCardIssueCriteriaCustomization(this.cardIssueCriteriaId, request)
        .then(() => {
          this.notifierStore.setSuccess("Card settings saved.");
          this.$emit("onSuccess");
        })
        .catch(() => {/*noop*/})
        .finally(() => {
          this.isSubmitting = false;
        });
    });
  }

  reset () {
    this.copyCardIssueCustomization();
  }

  // In the IssueCardCriteriaPlan table plan 'HSA' is set as the default,
  // thus it will be the first in the array and we check it by default.
  // Might want to query the array directly instead?
  setDefaultPlanThatReceiveCards () {
    if (this.isLoaded && this.cardCriteriaPlanOptions && this.cardCriteriaPlanOptions.length > 0) {
        this.selectedPlansThatReceiveCards.push(this.cardCriteriaPlanOptions[0].value);
    }
  }

  setDefaultMultiPursePlanFundId () {
    if (this.isLoaded && this.multiPurseFundOptions && this.multiPurseFundOptions.length >= 1) {
      this.cardIssueCustomizationModel.fundPurseId = this.multiPurseFundOptions[0].value;
    }
  }

  setDefaultFiservMultiPursePlanFundId () {
    if (this.isMultiPurseOverrideEnabled &&
      this.cardIssueCustomizationModel.fiservMultiPurseOverrideValueId === null &&
      this.multiPurseOverrideOptions.length >= 1) {
      this.cardIssueCustomizationModel.fiservMultiPurseOverrideValueId = this.multiPurseOverrideStore.multiPurseOverrides[0].multiPurseOverrideValueId;
    }
  }

  // Takes the data retrieved from the back end via the partnerCardIssueCriteriaStore
  // and hydrates the various ui objects.
  copyCardIssueCustomization () {
    if (this.isLoaded) {
      const customization = this.partnerCardIssueCriteriaStore.cardIssueCustomization(this.cardIssueCriteriaId);

      if (customization && customization.default) {
        this.cardIssueCustomizationModel = _.cloneDeep(customization.default);

        // this must come after we hydrate cardIssueCustomizationModel as it depends on feeScheduleId
        this.copyFeePackage();

        if (customization.default.plansThatReceiveCards && customization.default.plansThatReceiveCards.length > 0) {
          this.selectedPlansThatReceiveCards = customization.default.plansThatReceiveCards.map(plan => plan);
        }
      }
      else {
        this.cardIssueCustomizationModel = {...emptyCardCustomizationModel};
        this.setDefaultPlanThatReceiveCards();
        this.setDefaultMultiPursePlanFundId();
        this.setDefaultFiservMultiPursePlanFundId();
      }
    }
    else {
      this.cardIssueCustomizationModel = {...emptyCardCustomizationModel};
      this.feePackageQuery = "";
    }
  }

  copyFeePackage () {
    const selectedFeePackage = this.feePackageStore.feePackages.find(f => f.feeScheduleId === this.cardIssueCustomizationModel.feeScheduleId);

    if (selectedFeePackage) {
      this.feePackageQuery = selectedFeePackage.feePackageName;
    } else {
      this.feePackageQuery = "";
    }
  }

  onFeePackageInput () {
    this.cardIssueCustomizationModel.feeScheduleId = null;
  }

  feePackageSelected (item: FeePackageModel) {
    this.cardIssueCustomizationModel.feeScheduleId = item.feeScheduleId;
  }

  showOptionManagementModal (optionType: CardIssueCustomizationOptionType) {
    if (!manageableCardCustomizationOptionTypes.includes(optionType)) {
      return;
    }

    this.optionManagementModalParameters.optionType = optionType;
    this.optionManagementModalParameters.show.value = true;
  }

  noWhiteSpace = {
    getMessage () {
      return "Leading whitespace is not allowed.";
    },
    validate (primaryPersonalizedEmbossingText) {
      // regex tests for whitespace in the beginning.
      return new RegExp(/^[^\s]/).test(primaryPersonalizedEmbossingText);
    }
  };

  isValidUrl (errors): boolean {
    if (this.cardIssueCustomizationModel.url) {
      const urlTrimmed = this.cardIssueCustomizationModel.url.trim();
      return urlTrimmed && !errors.has("url");
    }

    return false;
  }
}
